import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

// SERVICES
import { IUser } from '../../interfaces/user.interface';
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _users = new BehaviorSubject<IUser[]>(<IUser[]>[]); // TODO: Add User Interface

  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  get(params :{ [param :string] :string | string[] }) :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/users`, { params })
      .subscribe({
        next: (response :{ records :IUser[] }) => {
          this._users.next(response.records || []);
          this._loading.next(false);
        },
        error: (error) => {
          this._loading.next(false);
        },
      });
  }

  search(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV1}/users/search`, {
      params,
    });
  }

  getByIds(params :{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV1}/users/find-by-ids`, {
      params,
    });
  }

  getAllUserAccount() :Observable<any> {
    return this.apiService.get(`${this.environment.urlV1}/users`);
  }

  get users() :Observable<IUser[]> {
    return this._users.asObservable();
  }
}
